<template>
  <!-- Tools -->
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card :title="title">
          <div class="flex flex-wrap">
            <vs-avatar color="danger" icon-pack="feather" icon="icon-info" class="pulse-danger" />
            <label class="mt-3 ml-2 bold">{{ subtitle }}</label>
            <vs-button
              color="danger"
              class="ml-2"
              size="small"
              icon-pack="feather"
              type="filled"
              @click="popupActivo = true"
              icon="icon-eye"
              >Ver</vs-button
            >
            <vs-button
              color="danger"
              class="ml-2"
              size="small"
              icon-pack="feather"
              type="filled"
              @click="$emit('refresh', 1)"
              icon="icon-refresh-cw"
              >Actualizar</vs-button
            >
          </div>
        </vx-card>
      </div>
    </div>
    <!-- MODAL DISPERSIONES -->
    <vs-popup class="mid-popup header-primary" :title="tableTitle" :active.sync="popupActivo">
      <vs-table
        ref="jobsTable"
        stripe
        :data="data"
        noDataText="No hay datos disponibles"
      >
        <template slot="thead">
          <vs-th>Referencia</vs-th>
          <vs-th>Inicio</vs-th>
          <vs-th>Estatus</vs-th>
          <vs-th>Ejecución</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
            <vs-td>{{ tr.reference }}</vs-td>
            <vs-td>{{ dateTimeFormat(tr.queue_time) }}</vs-td>
            <vs-td
              >{{ statusStr(tr.status) }}
              <vs-progress
                v-if="tr.status == 'started'"
                indeterminate
                color="danger"
              ></vs-progress
            ></vs-td>
            <vs-td>{{ dateTimeFormat(tr.start_time) }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!--  -->
  </div>
</template>

<script>
import dateHelper from "@mixins/dateHelper";
export default {
  name: "JobLog",
  props: ["title", "subtitle","tableTitle", "data"],
  mixins: [dateHelper],
  data() {
      return {
          popupActivo: false
      }
  },
  methods: {
    statusStr(status) {
      var statusStr = "En espera";
      switch (status) {
        case "started":
          statusStr = "En proceso";
          break;
        case "finished":
          statusStr = "Terminado";
          break;
        default:
          break;
      }
      return statusStr;
    },
  },
};
</script>
